import { useState, useRef } from "react";
import { PlayArrow } from "@material-ui/icons";

const LazyVideo = ({ src }) => {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  // Handle play button click
  const handlePlay = () => {
    setPlaying(true);
    videoRef.current?.play();
  };

  // Handle video ended
  const handleEnded = () => {
    setPlaying(false);
  };

  const handlePause = () => {
    setPlaying(false);
  };

  return (
    <div className="relative rounded-2xl border-2 border-[#950060] h-full">
      {/* Video Element - always rendered */}
      <video
        ref={videoRef}
        controls={playing}
        preload="metadata"
        onEnded={handleEnded}
        onPause={handlePause}
        className="w-full h-full object-fit rounded-2xl"
      >
        <source src={src + "#t=0.001"} type="video/mp4" />
        Your browser does not support the video.
      </video>

      {/* Thumbnail Overlay - shown when not playing */}
      {!playing && <div className="absolute rounded-2xl inset-0" />}

      {/* Play Button Overlay */}
      {!playing && (
        <button
          onClick={handlePlay}
          className="absolute inset-0 flex items-center justify-center group"
          aria-label="Play video"
        >
          <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-yellow-400 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-2xl">
            <PlayArrow style={{ fontSize: 50, color: "#450a0a" }} />
          </div>
        </button>
      )}
    </div>
  );
};

export default LazyVideo;
